import Box from '@mui/material/Box';
import React, { useState, useEffect } from 'react';
import FormControl from '@mui/material/FormControl';
import AutoComplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import tplHelpers from "../../../helpers/tpl";

function EditStatusPopup(props) {

    const selectedRowDetails = props.selectedRowDetails;
    
    const [status, setStatus] = useState(selectedRowDetails.status);
    const [notes, setNotes] = useState(selectedRowDetails.notes || "");
    const orderNbr = selectedRowDetails.acu_order_num;
    const shippedQty = selectedRowDetails.shipped;
    const receivedQty = selectedRowDetails.received;
    const sku = selectedRowDetails.sku;

    const statusOptions = [
        {value: 'Unresolved', name: 'Unresolved'},
        {value: 'Resolved', name: 'Resolved'}
    ];

    const updateStatus = async () => {
        props.setLoading(true);
        if (!status) {
            return props.toast.error("Must select a status.");
        };
        const payload = {
            status: status,
            notes: notes ? notes : null,
            acu_order_num: orderNbr,
            sku: sku
        };
        try {
            const res = await tplHelpers.updateDiscrepancies(payload, props.company, props.token);
            if (res.status === 200) {
                props.updateDiscrepancyState(selectedRowDetails, status, notes);
                props.handleClose();
            } else {
                throw new Error(res.error);
            };
        } catch (err) {
            console.log('save error', err);
            return props.toast.error('An error occurred ' + err);
        } finally {
            props.setLoading(false);
        };
    };

    useEffect(() => {
        if (selectedRowDetails) {
            props.updateSelectedDiscrepancy(orderNbr, sku);
        };
    }, [props.discrepancies]);

    return (
        <Dialog open = {props.open} onClose = {() => props.handleClose()} fullWidth = {true} maxWidth = {'md'}>
            <Box sx = {{ display: 'flex', alignItems: 'center', paddingTop: '1.5%' }}>
                <DialogTitle>
                        Edit Discrepancy Status
                </DialogTitle>
                <Button 
                    style = {{ marginLeft: "auto", marginRight: "5%", width: "10%" }} 
                    onClick = {() => props.handleClose()} 
                    disabled = {props.isLoading} 
                    endIcon = {<CloseIcon/>} 
                    color = "error"
                >
                    Cancel
                </Button>
            </Box>
            <DialogContent>
                <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{ display: 'flex', flexDirection: 'row' }}>
                      <TextField 
                        name = 'acu_order_num'
                        label = 'Acumatica Order Number'
                        value = {orderNbr}
                        sx = {{ width: '30%', mr: '0.6%' }}
                        disabled
                    />
                    <TextField 
                        name = 'sku'
                        label = 'SKU'
                        value = {sku}
                        sx = {{ width: '30%', mr: '0.6%' }}
                        disabled
                    />
                    <TextField 
                        name = 'shipped'
                        label = 'Shipped'
                        value = {shippedQty}
                        sx = {{ width: '20%', mr: '0.6%' }}
                        disabled
                    />
                    <TextField 
                        name = 'received'
                        label = 'Received'
                        value = {receivedQty}
                        sx = {{ width: '20%', mr: '0.6%' }}
                        disabled
                    />
                </Box>
                <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{display: 'flex', flexDirection: props.isMobile ? 'column' : 'row', mt: '10px'}}>
                    <FormControl sx = {{ width: '20%', mr: '0.6%' }}>
                        <AutoComplete
                            value = {status}
                            onChange = {(event, newValue) => {
                                setStatus(newValue ? newValue.value : null);
                            }}
                            isOptionEqualToValue = {(option, value) => option.value === value || value === ""}
                            selectOnFocus
                            clearOnBlur
                            handleHomeEndKeys
                            id = "status"  
                            options = {statusOptions} 
                            getOptionLabel = {(option) => {
                                if (typeof option === 'string') {
                                    return option;
                                }
                                if (option.inputValue) {
                                    return option.inputValue;
                                }
                                return option.value;
                            }}
                            renderOption = {(props, option) => {
                                const { key, ...optionProps } = props;
                                return (
                                <li key = {key} {...optionProps}>
                                    {option.value}
                                </li>
                                );
                            }}
                            renderInput = {(params) => (
                                <TextField {...params} label = "Status *" />
                            )}
                        />
                    </FormControl>
                    <TextField 
                        name = 'notes'
                        label = 'Notes'
                        value = {notes}
                        onChange = {(e) => setNotes(e.target.value)}
                        sx = {{ width: '70%', mr: '0.6%' }}
                    />
                    <DialogActions>
                        <Button 
                            variant = "contained" 
                            style = {{marginLeft: "auto", marginRight: "5%"}} 
                            sx = {{ width: '10%', mr: '0.6%' }}
                            onClick = {() => updateStatus()} 
                            disabled = {props.isLoading} 
                            color = "success" 
                        >
                            Save
                        </Button>
                    </DialogActions>
                </Box>
            </DialogContent>
        </Dialog>
    )
}

export default EditStatusPopup;